import actionTypes from '../constants/action-types';

const setSitesData = (sitesData) => ({
  type: actionTypes.SET_DATA,
  payload: { sitesData },
});

export default setSitesData;
